<template>
<div class="component">
    <filemap :isInEditMode="false" :existingrectangles="rectangles" />
<div class="button" @click="addRectangle()"></div>
</div>
</template>

<script>
import filemap from '@/views/filemap.vue'

export default {
    name: 'ProjectOverview',
    props: ["id"],
    mounted: function () {
        var newRectangle = {
            Left: 55,
            Right: 330,
            Top: 55,
            Bottom: 260
        }
        this.rectangles.push(newRectangle)
    
},
components: {
        filemap
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            rectangles:[],
        }
    },
    methods: {

       

        addRectangle(){
   var newRectangle = {
            Left: 15,
            Right: 33,
            Top: 5,
            Bottom: 26
        }
        this.rectangles.push(newRectangle)
        }
    },
    computed: {},
}
</script>

<style scoped>

</style>
